<template>
  <svg width="947" height="529" viewBox="0 0 947 529" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin: 0 auto">

    <rect width="947" height="529" fill="white"/>
    <line x1="30" y1="100.5" x2="914" y2="100.5" stroke="#CFD8DC"/>
    <text fill="#78909C" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16" letter-spacing="0.01em"><tspan x="30" y="77.2402">{{getDProcentData.sprRegionName }}</tspan>, {{getDProcentData.sprKcpGroupSprUslName }}: {{ getDProcentData.sprKcpGroupId }} {{ getDProcentData.sprKcpGroupName }}</text>
    <text fill="#00599B" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="22" letter-spacing="0.01em"><tspan x="30" y="43.68">Определение расчетной доли федерального бюджета в приеме
</tspan></text>
    <text fill="#00599B" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="22" letter-spacing="0.01em"><tspan x="30" y="43.68">Определение расчетной доли федерального бюджета в приеме
</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16" letter-spacing="0.01em"><tspan x="30" y="141.04">Доля федерального бюджета в приеме в целом по УГСН (НПС) не рассчитывается.
</tspan><tspan x="30" y="174.504">На схеме указано аналитическое значение, определенное как средневзвешенная по регионам расчетная </tspan><tspan x="30" y="196.968">доля федерального бюджета в приеме.
</tspan><tspan x="30" y="230.432">Как правило, она очень близка к доле федерального бюджета в приеме по УГСН (НПС) в отчетном году. </tspan><tspan x="30" y="252.896">Отклонения возникают в связи с прогнозным изменением региональной структуры трудоустройства </tspan><tspan x="30" y="275.36">выпускников. </tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16" letter-spacing="0.01em"><tspan x="30" y="466.04">Если в отчетном году по УГСН (НПС) не было приема, доля федерального бюджета в приеме </tspan><tspan x="30" y="488.504">принимается равной 1.</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16" font-weight="600" letter-spacing="0.01em"><tspan x="30" y="336.04">Доля принятых на обучение за счет федерального бюджета в отчетном году:</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="16" font-weight="600" letter-spacing="0.01em"><tspan x="30" y="400.04">Расчетная доля федерального бюджета в приеме:</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="47" letter-spacing="0.01em"><tspan x="665" y="348.18">{{ $scripts.TableJs.checkValueWithNullAndReturnND(Number.isNaN(getDProcentData.dfb * 100) ? (getDProcentData.dfb === 'н.д.' ? 'н.д.': 'x'): getDProcentData.dfb * 100, 1, 'float', true,  'н.д.', '',(v) => v + '%') }}</tspan></text>
    <text fill="#263238" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="47" letter-spacing="0.01em"><tspan x="665" y="413.18">{{ $scripts.TableJs.checkValueWithNullAndReturnND(Number.isNaN(getDProcentData.d * 100) ? (getDProcentData.d === 'н.д.' ? 'н.д.': 'x'): getDProcentData.d * 100, 1, 'float', true,  'н.д.', '',(v) => v + '%') }}</tspan></text>
  </svg>

</template>

<script>
import request from "@/services/request";
import {svgPropsMapper} from "@/mixins/svgPropsMapper";

export default {
  name: "DnoRf",
  mixins: [svgPropsMapper],
  props: {
    kcpGroupId: null,
    regionId: null,
  },
  data() {
    return {
      getDProcentData: {
        id: 0,
        sprKcpGroupId: "string",
        sprKcpGroupName: "string",
        sprKcpGroupSprUslName: "string",
        sprRegionId: "string",
        sprRegionName: "string",
        sprRegionNameGenitive: "string",
        dfb: 0,
        k1: 0,
        k2: 0,
        k3: 0,
        dpr: 0,
        k0: 0,
        d: 0,
        m: 0
      },
    }
  },
  async created() {
    await this.getD_Svg();
  },
  methods: {
    async getD_Svg() {
      try {
        const res = await request({
          endpoint: `/api/information/getDproc?kcpGroupId=${this.kcpGroupId}`,
          method: 'get',
        });
        if (res.status === 200 ) {
          console.log('getD_Svg успех');
          if (res.data) {
            this.mapServerData(res.data);
          }else
            this.mapServerData();
        }
        this.changeDefaultValues()
      } catch (e) {
        console.log(e);
      }
    },
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;700');
@import url('https://fonts.googleapis.com/css2?family=PT+Serif');

text {
  font-feature-settings: 'pnum' on, 'lnum' on;
}
</style>